
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1m0-1A12,12,0,1,0,24,12,12,12,0,0,0,12,0"}}),_vm._v(" "),_c('g',{attrs:{"opacity":"0.297"}},[_c('path',{attrs:{"d":"M17,9H7A1,1,0,0,1,7,7H17a1,1,0,0,1,0,2"}}),_c('path',{attrs:{"d":"M17,13H7a1,1,0,0,1,0-2H17a1,1,0,0,1,0,2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M13,17H7a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2"}})])])}
var staticRenderFns = []

    export default {
      render: render,
    }
  